import React from 'react';
import { ClientContext, ServicesContext, useAdminService } from '~/services';
import { DatePicker } from '~/components/Form';
import { moment } from '~/vendorConfigs/moment';

export function ReportYear() {
    const servicesContext = React.useContext(ServicesContext);
    const { setReportYearDates } = useAdminService();
    const { reportYearDates } = React.useContext(ClientContext);
    const [attDate, setAttDate] = React.useState(reportYearDates.attDate);
    const [focDate, setFocDate] = React.useState(reportYearDates.focDate);
    const [quaDate, setQuaDate] = React.useState(reportYearDates.quaDate);
    const [isLoading, setLoading] = React.useState(false);

    async function saveDates() {
        setLoading(true);
        try {
            await setReportYearDates({ attDate, focDate, quaDate });
        } finally {
            setLoading(false);
        }
    }

    function formatDate(date: undefined | Date) {
        if (typeof date === 'undefined') return null;
        return moment(date).format('MM/DD/YYYY');
    }

    return (
        <div className="mt-4">
            <div className="row align-items-center mb-2">
                <label className="form-label col-2 fw-bold" htmlFor="attestation">
                    Attestation
                </label>
                <div className="col">
                    {servicesContext.user.isReportYearAdmin() ? (
                        <DatePicker name="attestation" value={attDate} onChange={setAttDate} />
                    ) : (
                        formatDate(attDate)
                    )}
                </div>
            </div>
            <div className="row align-items-center mb-2">
                <label className="form-label col-2 fw-bold" htmlFor="foc">
                    AW
                </label>
                <div className="col">
                    {servicesContext.user.isReportYearAdmin() ? (
                        <DatePicker name="foc" value={focDate} onChange={setFocDate} />
                    ) : (
                        formatDate(focDate)
                    )}
                </div>
            </div>
            <div className="row align-items-center mb-2">
                <label className="form-label col-2 fw-bold" htmlFor="quality">
                    Quality
                </label>
                <div className="col">
                    {servicesContext.user.isReportYearAdmin() ? (
                        <DatePicker name="quality" value={quaDate} onChange={setQuaDate} />
                    ) : (
                        formatDate(quaDate)
                    )}
                </div>
            </div>
            {servicesContext.user.isReportYearAdmin() && (
                <div className="row">
                    <div className="col offset-2">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={saveDates}
                            disabled={isLoading}
                        >
                            {isLoading && <i className="fa-solid fa-spin fa-spinner me-2" />}
                            Save
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
